import {
  FETCH_USER_MERCHANT_ACCOUNTS_INIT,
  FETCH_USER_MERCHANT_ACCOUNTS_SUCCESS,
  FETCH_USER_MERCHANT_ACCOUNTS_ERROR,
  UPDATE_MERCHANT_ACCOUNT_INIT,
  UPDATE_MERCHANT_ACCOUNT_SUCCESS,
  UPDATE_MERCHANT_ACCOUNT_ERROR,
  ADD_MERCHANT_ACCOUNT_INIT,
  ADD_MERCHANT_ACCOUNT_SUCCESS,
  ADD_MERCHANT_ACCOUNT_ERROR,
  FETCH_MERCHANT_ACCOUNTS_INIT,
  FETCH_MERCHANT_ACCOUNTS_SUCCESS,
  FETCH_MERCHANT_ACCOUNTS_ERROR,
  FETCH_MERCHANT_BENEFICIARIES_INIT,
  FETCH_MERCHANT_BENEFICIARIES_SUCCESS,
  FETCH_MERCHANT_BENEFICIARIES_ERROR,
  CREATE_MERCHANT_BENEFICIARY_INIT,
  CREATE_MERCHANT_BENEFICIARY_SUCCESS,
  CREATE_MERCHANT_BENEFICIARY_ERROR,
  UPDATE_MERCHANT_BENEFICIARY_INIT,
  UPDATE_MERCHANT_BENEFICIARY_SUCCESS,
  UPDATE_MERCHANT_BENEFICIARY_ERROR,
  DELETE_MERCHANT_BENEFICIARY_INIT,
  DELETE_MERCHANT_BENEFICIARY_SUCCESS,
  DELETE_MERCHANT_BENEFICIARY_ERROR,
  SET_SELECTED_MERCHANT_ACCOUNT,
  SEARCH_MERCHANT_ACCOUNTS,
  SEARCH_PROCESSORS,
  UPDATE_API_TOKEN_INIT,
  UPDATE_API_TOKEN_SUCCESS,
  UPDATE_API_TOKEN_ERROR,
  FETCH_API_TOKENS_INIT,
  FETCH_API_TOKENS_SUCCESS,
  FETCH_API_TOKENS_ERROR,
  FETCH_WALLETS_INIT,
  FETCH_WALLETS_SUCCESS,
  FETCH_WALLETS_ERROR,
  FETCH_WALLETS_AGG_BALANCE_INIT,
  FETCH_WALLETS_AGG_BALANCE_SUCCESS,
  FETCH_WALLETS_AGG_BALANCE_ERROR,
  FETCH_WALLETS_AGG_ROLLING_RESERVE_INIT,
  FETCH_WALLETS_AGG_ROLLING_RESERVE_SUCCESS,
  FETCH_WALLETS_AGG_ROLLING_RESERVE_ERROR,
  FETCH_WALLET_OVERVIEW_INIT,
  FETCH_WALLET_OVERVIEW_SUCCESS,
  FETCH_WALLET_OVERVIEW_ERROR,
  FETCH_WALLET_OVERVIEW_PER_PSP_INIT,
  FETCH_WALLET_OVERVIEW_PER_PSP_SUCCESS,
  FETCH_WALLET_OVERVIEW_PER_PSP_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE,
  CREATE_SETTLEMENT_REPORT_INIT,
  CREATE_SETTLEMENT_REPORT_SUCCESS,
  CREATE_SETTLEMENT_REPORT_ERROR,
  FETCH_SETTLEMENT_REPORT_INIT,
  FETCH_SETTLEMENT_REPORT_SUCCESS,
  FETCH_SETTLEMENT_REPORT_ERROR,
  DELETE_SETTLEMENT_REPORT_INIT,
  DELETE_SETTLEMENT_REPORT_SUCCESS,
  DELETE_SETTLEMENT_REPORT_ERROR,
  UPDATE_SETTLEMENT_REPORT_INIT,
  UPDATE_SETTLEMENT_REPORT_SUCCESS,
  UPDATE_SETTLEMENT_REPORT_ERROR,
  FETCH_SETTLEMENT_REPORT_SUMMARY_INIT,
  FETCH_SETTLEMENT_REPORT_SUMMARY_SUCCESS,
  FETCH_SETTLEMENT_REPORT_SUMMARY_ERROR,
  CREATE_MERCHANT_ACCOUNT_INIT,
  CREATE_MERCHANT_ACCOUNT_SUCCESS,
  CREATE_MERCHANT_ACCOUNT_ERROR,
  SET_ACTIVE_MERCHANT_ACCOUNT,
  GENERATE_API_KEY_INIT,
  GENERATE_API_KEY_SUCCESS,
  GENERATE_API_KEY_ERROR,
  UPDATE_API_KEY_INIT,
  UPDATE_API_KEY_SUCCESS,
  UPDATE_API_KEY_ERROR,
  DELETE_API_KEY_INIT,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_ERROR,
  FETCH_API_KEYS_INIT,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_ERROR,
  FETCH_AFFILIATE_MERCHANT_ACCOUNTS_INIT,
  FETCH_AFFILIATE_MERCHANT_ACCOUNTS_SUCCESS,
  FETCH_AFFILIATE_MERCHANT_ACCOUNTS_ERROR,
  DELETE_MERCHANT_ACCOUNT_SUCCESS,
  DELETE_MERCHANT_ACCOUNT_INIT,
  DELETE_MERCHANT_ACCOUNT_ERROR,
  FETCH_TRAFFIC_WEBSITES_START,
  FETCH_TRAFFIC_WEBSITES_ERROR,
  FETCH_TRAFFIC_WEBSITES_SUCCESS,
  ADD_TRAFFIC_WEBSITE_ERROR,
  ADD_TRAFFIC_WEBSITE_START,
  ADD_TRAFFIC_WEBSITE_SUCCESS,
  UPDATE_TRAFFIC_WEBSITE_START,
  UPDATE_TRAFFIC_WEBSITE_SUCCESS,
  UPDATE_TRAFFIC_WEBSITE_ERROR,
  FETCH_SELECTED_MERCHANT_ACCOUNT,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  merchantCharges: {
    data: [],
    loading: false,
    error: null,
    creatingMerchantCharge: false,
    deletingMerchantCharge: false,
    updatingMerchantCharge: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 10,
  },
  searchMerchants: [],
  merchantAccounts: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  trafficWebsites: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  affiliateMerchantAccounts: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  searchMerchantAccounts: {
    data: [],
    loading: false,
  },
  userMerchantAccounts: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  updateMerchant: {
    loading: false,
    merchant: {},
    error: null,
  },
  selectedMerchantAccount: {
    loading: false,
    selectedMerchant: {},
    error: null,
  },
  selectedMerchantType: {},
  selectedProcessingType: {},
  apiTokens: {
    data: [],
    loading: false,
    updatingToken: false,
  },
  settlementReports: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 100,
    totalItems: 0,
    creatingSettlementReport: false,
    autoSaveExecuted: false,
    deletingSettlementReport: false,
    updatingSettlementReport: false,
  },
  wallets: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
  walletsAGGBalance: {
    data: [],
    loading: false,
    error: null,
  },
  walletsAGGRollingReserve: {
    data: [],
    loading: false,
    error: null,
  },
  walletOverview: {
    data: [],
    loading: false,
    error: null,
    COLLECTION: {},
    REFUND: {},
    CHARGEBACK: {},
    DEPOSIT: {},
    DISBURSEMENT: {},
    SETTLEMENT: {},
    WITHDRAWAL: {},
  },
  walletOverviewPerPSP: {
    data: [],
    loading: false,
    error: null,
    COLLECTION: {},
    REFUND: {},
    CHARGEBACK: {},
    DEPOSIT: {},
    DISBURSEMENT: {},
    SETTLEMENT: {},
    WITHDRAWAL: {},
  },
  settlementReportSummary: {
    data: [],
    loading: false,
    error: null,
  },
  activeWallet: {},
  activeMerchant: {},
  apiKeys: {
    data: [],
    loading: false,
    error: null,
    creatingKey: false,
    latestKey: {},
    updatingKey: false,
    deletingKey: false,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    case FETCH_TRAFFIC_WEBSITES_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case ADD_TRAFFIC_WEBSITE_ERROR:
    case UPDATE_TRAFFIC_WEBSITE_ERROR:
    case FETCH_TRAFFIC_WEBSITES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case FETCH_MERCHANT_ACCOUNTS_INIT: {
      return {
        ...state,
        merchantAccounts: {
          loading: true,
        },
      };
    }

    case FETCH_MERCHANT_ACCOUNTS_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      const merchantId = sessionStorage.getItem('activeMerchant');
      let storedMerchant = {};
      // eslint-disable-next-line prefer-destructuring
      const firstMerchant = data[0];

      if (merchantId) {
        storedMerchant = data.find((value) => value._id === merchantId);
      }

      const merchantObject = storedMerchant !== undefined ? storedMerchant : firstMerchant;

      sessionStorage.setItem('activeMerchant', merchantObject._id);

      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          loading: false,
          data,
          totalItems,
          currentPage,
        },
        activeMerchant: merchantObject,
      };
    }

    case FETCH_MERCHANT_ACCOUNTS_ERROR: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          loading: false,
        },
      };
    }

    case FETCH_AFFILIATE_MERCHANT_ACCOUNTS_INIT: {
      return {
        ...state,
        affiliateMerchantAccounts: {
          ...state.affiliateMerchantAccounts,
          loading: true,
        },
      };
    }

    case FETCH_AFFILIATE_MERCHANT_ACCOUNTS_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        affiliateMerchantAccounts: {
          ...state.affiliateMerchantAccounts,
          loading: false,
          data,
          totalItems,
          currentPage,
        },
      };
    }

    case FETCH_AFFILIATE_MERCHANT_ACCOUNTS_ERROR: {
      return {
        ...state,
        affiliateMerchantAccounts: {
          ...state.affiliateMerchantAccounts,
          loading: false,
        },
      };
    }

    case FETCH_USER_MERCHANT_ACCOUNTS_INIT: {
      return {
        ...state,
        userMerchantAccounts: {
          ...state.userMerchantAccounts,
          loading: true,
        },
      };
    }

    case FETCH_USER_MERCHANT_ACCOUNTS_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        userMerchantAccounts: {
          ...state.userMerchantAccounts,
          loading: false,
          data,
          totalItems,
          currentPage,
        },
      };
    }

    case FETCH_USER_MERCHANT_ACCOUNTS_ERROR: {
      return {
        ...state,
        userMerchantAccounts: {
          ...state.userMerchantAccounts,
          loading: false,
        },
      };
    }

    case ADD_MERCHANT_ACCOUNT_INIT: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          addingMerchantAccount: true,
        },
      };
    }

    case ADD_MERCHANT_ACCOUNT_SUCCESS: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          addingMerchantAccount: false,
          data: [action.payload, ...state.merchantAccounts.data],
        },
      };
    }

    case ADD_MERCHANT_ACCOUNT_ERROR: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          addingMerchantAccount: false,
        },
      };
    }

    case UPDATE_MERCHANT_ACCOUNT_INIT: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          updatingMerchantAccount: true,
        },
      };
    }

    case UPDATE_MERCHANT_ACCOUNT_SUCCESS: {
      const allMerchantAccounts = state.merchantAccounts.data;
      const updatedData = allMerchantAccounts.filter(
        (merchantAccount) => merchantAccount._id !== action.payload._id,
      );
      updatedData.push(action.payload);
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          updatingMerchantAccount: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_MERCHANT_ACCOUNT_ERROR: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          updatingMerchantAccount: false,
        },
      };
    }

    case FETCH_SELECTED_MERCHANT_ACCOUNT: {
      return {
        ...state,
        selectedMerchantAccount: {
          ...state.selectedMerchantAccount,
          loading: true,
        },
      };
    }

    case SET_SELECTED_MERCHANT_ACCOUNT: {
      return {
        ...state,
        selectedMerchantAccount: {
          loading: false,
          selectedMerchant: action.payload,
          error: null,
        },
      };
    }

    case CREATE_MERCHANT_BENEFICIARY_INIT: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          creatingMerchantCharge: true,
        },
      };
    }

    case CREATE_MERCHANT_BENEFICIARY_SUCCESS: {
      const merchantCharges = state.merchantCharges.data;
      merchantCharges.push(action.payload);

      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          creatingMerchantCharge: false,
          data: merchantCharges,
        },
      };
    }

    case CREATE_MERCHANT_BENEFICIARY_ERROR: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          creatingMerchantCharge: false,
        },
      };
    }

    case FETCH_MERCHANT_BENEFICIARIES_INIT: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          loading: true,
        },
      };
    }

    case FETCH_MERCHANT_BENEFICIARIES_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          loading: false,
          data,
          totalItems,
          currentPage,
        },
      };
    }

    case FETCH_MERCHANT_BENEFICIARIES_ERROR: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          loading: false,
          error: true,
        },
      };
    }

    case UPDATE_MERCHANT_BENEFICIARY_INIT: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          updatingMerchantCharge: true,
        },
      };
    }

    case UPDATE_MERCHANT_BENEFICIARY_SUCCESS: {
      const updatedData = state.merchantCharges.data;
      const index = updatedData.findIndex(
        (key) => key._id === action.payload._id,
      );
      updatedData[index] = action.payload;
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          updatingMerchantCharge: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_MERCHANT_BENEFICIARY_ERROR: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          updatingMerchantCharge: false,
        },
      };
    }

    case DELETE_MERCHANT_BENEFICIARY_INIT: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          deletingMerchantCharge: true,
        },
      };
    }

    case DELETE_MERCHANT_BENEFICIARY_SUCCESS: {
      const updatedData = state.merchantCharges.data.filter(
        (type) => type._id !== action.payload,
      );

      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          deletingMerchantCharge: false,
          data: updatedData,
        },
      };
    }

    case DELETE_MERCHANT_BENEFICIARY_ERROR: {
      return {
        ...state,
        merchantCharges: {
          ...state.merchantCharges,
          deletingMerchantCharge: false,
        },
      };
    }

    case SEARCH_MERCHANT_ACCOUNTS: {
      return {
        ...state,
        searchMerchants: action.payload,
      };
    }

    case SEARCH_PROCESSORS: {
      return {
        ...state,
        searchProcessors: action.payload,
      };
    }

    case UPDATE_API_TOKEN_INIT: {
      return {
        ...state,
        apiTokens: {
          ...state.apiTokens,
          updatingToken: true,
        },
      };
    }

    case UPDATE_API_TOKEN_SUCCESS: {
      const keys = state.apiTokens.data;
      const index = keys.findIndex(
        (key) => key._id === action.payload._id,
      );
      keys[index] = action.payload;
      return {
        ...state,
        apiTokens: {
          ...state.apiTokens,
          updatingToken: false,
          data: keys,
        },
      };
    }

    case UPDATE_API_TOKEN_ERROR: {
      return {
        ...state,
        apiTokens: {
          ...state.apiTokens,
          updatingToken: false,
        },
      };
    }

    case FETCH_API_TOKENS_INIT: {
      return {
        ...state,
        apiTokens: {
          ...state.apiTokens,
          loading: true,
        },
      };
    }

    case FETCH_API_TOKENS_SUCCESS: {
      return {
        ...state,
        apiTokens: {
          ...state.apiTokens,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_API_TOKENS_ERROR: {
      return {
        ...state,
        apiTokens: {
          ...state.apiTokens,
          loading: false,
        },
      };
    }

    case FETCH_WALLETS_INIT: {
      return {
        ...state,
        wallets: {
          ...state.wallets,
          loading: true,
        },
      };
    }

    case FETCH_WALLETS_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;
      return {
        ...state,
        wallets: {
          ...state.wallets,
          loading: false,
          totalItems,
          currentPage,
          data,
        },
      };
    }

    case FETCH_WALLETS_ERROR: {
      return {
        ...state,
        wallets: {
          ...state.wallets,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_WALLETS_AGG_BALANCE_INIT: {
      return {
        ...state,
        walletsAGGBalance: {
          ...state.walletsAGGBalance,
          loading: true,
        },
      };
    }

    case FETCH_WALLETS_AGG_BALANCE_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        walletsAGGBalance: {
          ...state.walletsAGGBalance,
          loading: false,
          data,
        },
      };
    }

    case FETCH_WALLETS_AGG_BALANCE_ERROR: {
      return {
        ...state,
        walletsAGGBalance: {
          ...state.walletsAGGBalance,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_WALLETS_AGG_ROLLING_RESERVE_INIT: {
      return {
        ...state,
        walletsAGGRollingReserve: {
          ...state.walletsAGGRollingReserve,
          loading: true,
        },
      };
    }

    case FETCH_WALLETS_AGG_ROLLING_RESERVE_SUCCESS: {
      const data = action.payload;

      return {
        ...state,
        walletsAGGRollingReserve: {
          ...state.walletsAGGRollingReserve,
          loading: false,
          data,
        },
      };
    }

    case FETCH_WALLETS_AGG_ROLLING_RESERVE_ERROR: {
      return {
        ...state,
        walletsAGGRollingReserve: {
          ...state.walletsAGGRollingReserve,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_WALLET_OVERVIEW_INIT: {
      return {
        ...state,
        walletOverview: {
          ...state.walletOverview,
          loading: true,
        },
      };
    }

    case FETCH_WALLET_OVERVIEW_SUCCESS: {
      const data = action.payload;
      const { transactionType } = action;

      const byTransactionType = {};
      if (transactionType) {
        byTransactionType[`${transactionType}`] = data;
      }

      return {
        ...state,
        walletOverview: {
          ...state.walletOverview,
          loading: false,
          data,
          ...byTransactionType,
        },
      };
    }

    case FETCH_WALLET_OVERVIEW_ERROR: {
      return {
        ...state,
        walletOverview: {
          ...state.walletOverview,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_WALLET_OVERVIEW_PER_PSP_INIT: {
      return {
        ...state,
        walletOverviewPerPSP: {
          ...state.walletOverviewPerPSP,
          loading: true,
        },
      };
    }

    case FETCH_WALLET_OVERVIEW_PER_PSP_SUCCESS: {
      const data = action.payload;
      const { transactionType } = action;

      const byTransactionType = {};
      if (transactionType) {
        byTransactionType[`${transactionType}`] = data;
      }

      return {
        ...state,
        walletOverviewPerPSP: {
          ...state.walletOverviewPerPSP,
          loading: false,
          data,
          ...byTransactionType,
        },
      };
    }

    case FETCH_WALLET_OVERVIEW_PER_PSP_ERROR: {
      return {
        ...state,
        walletOverviewPerPSP: {
          ...state.walletOverviewPerPSP,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_SETTLEMENT_REPORT_SUMMARY_INIT: {
      return {
        ...state,
        settlementReportSummary: {
          ...state.settlementReportSummary,
          loading: true,
        },
      };
    }

    case FETCH_SETTLEMENT_REPORT_SUMMARY_SUCCESS: {
      const data = action.payload;

      return {
        ...state,
        settlementReportSummary: {
          ...state.settlementReportSummary,
          loading: false,
          data,
        },
      };
    }

    case FETCH_SETTLEMENT_REPORT_SUMMARY_ERROR: {
      return {
        ...state,
        settlementReportSummary: {
          ...state.settlementReportSummary,
          loading: false,
          error: action.payload,
        },
      };
    }

    case CREATE_SETTLEMENT_REPORT_INIT: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          creatingSettlementReport: true,
        },
      };
    }

    case CREATE_SETTLEMENT_REPORT_SUCCESS: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          creatingSettlementReport: false,
          autoSaveExecuted: true,
        },
      };
    }

    case CREATE_SETTLEMENT_REPORT_ERROR: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          creatingSettlementReport: false,
          error: action.payload,
          autoSaveExecuted: true,
        },
      };
    }

    case FETCH_SETTLEMENT_REPORT_INIT: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          loading: true,
        },
      };
    }

    case FETCH_SETTLEMENT_REPORT_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          loading: false,
          data,
          totalItems,
          currentPage,
        },
      };
    }

    case FETCH_SETTLEMENT_REPORT_ERROR: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          loading: false,
          error: true,
        },
      };
    }

    case DELETE_SETTLEMENT_REPORT_INIT: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          deletingSettlementReport: true,
        },
      };
    }

    case DELETE_SETTLEMENT_REPORT_SUCCESS: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          deletingSettlementReport: false,
        },
      };
    }

    case DELETE_SETTLEMENT_REPORT_ERROR: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          deletingSettlementReport: false,
          error: action.payload,
        },
      };
    }

    case UPDATE_SETTLEMENT_REPORT_INIT: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          updatingSettlementReport: true,
        },
      };
    }

    case UPDATE_SETTLEMENT_REPORT_SUCCESS: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          updatingSettlementReport: false,
        },
      };
    }

    case UPDATE_SETTLEMENT_REPORT_ERROR: {
      return {
        ...state,
        settlementReports: {
          ...state.settlementReports,
          updatingSettlementReport: false,
          error: action.payload,
        },
      };
    }

    case SET_ACTIVE_MERCHANT_ACCOUNT:
      {
        const activeMerchantId = sessionStorage.getItem('activeMerchant');
        const merchant = activeMerchantId && state.merchantAccounts
          && state.merchantAccounts.data
          && state.merchantAccounts.data.find((value) => value._id === activeMerchantId);
        return {
          ...state,
          activeMerchant: merchant,
        };
      }

    case GENERATE_API_KEY_INIT: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          creatingKey: true,
        },
      };
    }

    case GENERATE_API_KEY_SUCCESS: {
      //const keys = state.apiKeys.data;
      //keys.push(action.payload);
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          creatingKey: false,
          data: [action.payload, ...state.apiKeys.data],
          latestKey: action.payload
        },
      };
    }

    case GENERATE_API_KEY_ERROR: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          creatingKey: false,
        },
      };
    }

    case UPDATE_API_KEY_INIT: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          updatingKey: true,
        },
      };
    }

    case UPDATE_API_KEY_SUCCESS: {
      const allApiKeys = state.apiKeys.data;
      const updatedData = allApiKeys.filter(
        (apiKey) => apiKey._id !== action.payload._id,
      );
      updatedData.push(action.payload);
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          updatingApiKey: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_API_KEY_ERROR: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          updatingKey: false,
        },
      };
    }

    case DELETE_API_KEY_INIT: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          deletingKey: true,
        },
      };
    }

    case DELETE_API_KEY_SUCCESS: {
      const updatedData = state.apiKeys.data.filter(
        (type) => type._id !== action.payload,
      );

      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          deletingKey: false,
          data: updatedData,
        },
      };
    }

    case DELETE_API_KEY_ERROR: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          deletingKey: false,
        },
      };
    }

    case FETCH_API_KEYS_INIT: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          loading: true,
        },
      };
    }

    case FETCH_API_KEYS_SUCCESS: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_API_KEYS_ERROR: {
      return {
        ...state,
        apiKeys: {
          ...state.apiKeys,
          loading: false,
        },
      };
    }

    case CREATE_MERCHANT_ACCOUNT_INIT: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          creatingMerchant: true,
        },
      };
    }

    case CREATE_MERCHANT_ACCOUNT_SUCCESS: {
      const allMerchants = state.merchantAccounts.data;
      allMerchants.push(action.payload);

      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          creatingMerchant: false,
          data: allMerchants,
        },
      };
    }

    case CREATE_MERCHANT_ACCOUNT_ERROR: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          creatingMerchant: false,
        },
      };
    }

    case DELETE_MERCHANT_ACCOUNT_INIT: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          deletingMerchantAccount: true,
        },
      };
    }

    case DELETE_MERCHANT_ACCOUNT_SUCCESS: {
      const updatedData = state.merchantAccounts.data.filter(
        (type) => type._id !== action.payload,
      );

      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          deletingmerchantAccount: false,
          data: updatedData,
        },
      };
    }

    case DELETE_MERCHANT_ACCOUNT_ERROR: {
      return {
        ...state,
        merchantAccounts: {
          ...state.merchantAccounts,
          deletingmerchantAccount: false,
        },
      };
    }


    case FETCH_TRAFFIC_WEBSITES_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        meta: { ...state.meta, ...action.meta },
      };
    }

    case ADD_TRAFFIC_WEBSITE_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        meta: { ...state.meta, ...action.meta },
      };
    }

    case UPDATE_TRAFFIC_WEBSITE_SUCCESS: {
      const updatedData = state.data.map(
        (trafficWebsite) => (
          trafficWebsite._id !== action.payload._id ? trafficWebsite : action.payload
        ),
      );
      return {
        ...state,
        loading: false,
        data: updatedData,
      };
    }

    default:
      return state;
  }
};
